import { DictType } from 'core-lib/types/Helper';
import Product from './product';

export enum LayoutType {
  SearchBar = 'SEARCH_BAR',
  CategoryListing = 'CATEGORY_LISTING',
  BannerListing = 'BANNER_LISTING',
  FullWidthBannerListing = 'FULL_WIDTH_BANNER_LISTING', // this will take full width of the page
  BestDealsListing = 'BEST_DEALS_LISTING',
  GridListing = 'GRID_LISTING',
  ScrollListing = 'SCROLL_LISTING',
  GridScrollListing = 'GRID_SCROLL_LISTING',
  PetrolVoucherListing = 'PETROL_VOUCHER_LISTING',
  FilterListing = 'FILTER_LISTING',
  ProductSuggestion = 'PRODUCT_SUGGESTION',
  StackListing = 'STACK_LISTING',
  CenteredCardListing = 'CENTERED_CARD_LISTING',
  ImageScrollListing = 'IMAGE_SCROLL_LISTING',
  ImageGridScrollListing = 'IMAGE_GRID_SCROLL_LISTING',
  BrowseCategoryListing = 'BROWSE_CATEGORY_LISTING',
  NoResult = 'NO_RESULT',
  FreeMlListing = 'FREE_ML_LISTING',
  MarqueeListing = 'MARQUEE_LISTING',
  VideoListing = 'VIDEO_LISTING',
  VideoCarousel = 'VIDEO_CAROUSEL',
  WeekendManiaListing = 'WEEKEND_MANIA_LISTING',
  FilterScrollListing = 'FILTER_SCROLL_LISTING',
  VoteToSlashPrice = 'VOTE_TO_SLASH_PRICE',
  FlashListing = 'FLASH_LISTING',
  GridListingSale = 'GRID_LISTING_SALE',
  BestOffersListing = 'BEST_OFFERS_LISTING',
  CategoryCoverListing = 'CATEGORY_COVER_LISTING',
  StripBannerListing = 'STRIP_BANNER_LISTING',
  FloatingScrollListing = 'FLOATING_SCROLL_LISTING',
  ProductOfTheDayListing = 'PRODUCT_OF_THE_DAY',
  BottomSheetListing = 'BOTTOM_SHEET_LISTING',
}

export type LayoutMetaData = {
  expiresIn?: Date;
  savings?: number;
  remainingUnlocks?: number;
  listingOrder?: number[]; // for maintaining grid listing order
  headingImage?: string;
  categories?: Product[];
  autoplay?: boolean;
  onClick?: boolean;
  showDrop?: boolean;
  subtitle1?: string;
  subtitle2?: string;
  videoUrl?: string;
  videoText?: string;
  eventExpiryTime?: string;
  campaignId?: number;
  clockWatchIcon?: string;
  comeBackTime?: string;
  slashPriceEndsIn?: string;
  starIcon?: string;
};

type Layout = {
  layoutId: number;
  layoutType: LayoutType;
  entityType?: LayoutEntityType;
  data: Product[];
  title?: string;
  subtitle?: string;
  ctaText?: string;
  backgroundImage?: string;
  votedProductId?: number;
  metaData?: LayoutMetaData;
  backgroundColor?: string;
  textColor?: string;
  sectionName?: string;
  endTime?: Date;
  screenId?: string;
  screenData?: DictType;
};

export enum LayoutEntityType {
  Collection = 'COLLECTION',
  Product = 'PRODUCT',
  ProductListing = 'PRODUCT_LISTING',
  Category = 'CATEGORY',
}

export type LayoutPropType = {
  data: Layout;
  index?: number;
};

export default Layout;
